import(/* webpackMode: "eager", webpackExports: ["ClientLayout"] */ "/Users/bpico/Development/nuvation/ibtrozi.com/apps/full-promo/src/app/clientLayout.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/bpico/Development/nuvation/ibtrozi.com/apps/full-promo/src/app/GlobalStyles.js");
;
import(/* webpackMode: "eager" */ "/Users/bpico/Development/nuvation/ibtrozi.com/node_modules/@mui/material-nextjs/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager" */ "/Users/bpico/Development/nuvation/ibtrozi.com/node_modules/next/dist/client/script.js");
